import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Building2, FileText, Clock } from 'lucide-react';
import { ProtectedEmail, ProtectedPhone } from '../components/ProtectedContact';

export default function Impressum() {
  return (
    <div className="section-spacing" data-testid="impressum-page">
      <div className="container-wide">
        {/* Breadcrumb */}
        <nav className="text-sm text-[#64748B] mb-8" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-[#0284C7]">Start</Link>
          <span className="mx-2">/</span>
          <span className="text-[#0F172A]">Impressum</span>
        </nav>

        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-8 font-[var(--font-heading)]">
            Impressum
          </h1>

          {/* Angaben gemäß Gesetz */}
          <div className="bg-white rounded-xl p-8 border border-[#E2E8F0] mb-8">
            <h2 className="text-xl font-semibold text-[#0F172A] mb-6 font-[var(--font-heading)]">
              Angaben gemäß Art. 2 D.Lgs. 70/2003 und § 5 TMG
            </h2>
            
            <div className="space-y-6 text-[#475569]">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <Building2 className="text-[#0284C7]" size={18} />
                  <span className="font-semibold text-[#0F172A]">Betreiber der Website</span>
                </div>
                <p className="font-medium text-[#0F172A] text-lg">HAFNER EC GmbH</p>
                <p>Bauunternehmen</p>
              </div>

              <div className="flex items-start gap-3">
                <MapPin className="text-[#0284C7] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="font-medium text-[#0F172A]">Firmensitz</p>
                  <p>Sinich-Bach-Str. 60</p>
                  <p>I-39012 Meran (BZ)</p>
                  <p>Südtirol, Italien</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Phone className="text-[#0284C7] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="font-medium text-[#0F172A]">Telefon & Fax</p>
                  <p>Tel.: <ProtectedPhone /></p>
                  <p>Fax: +39 0473 257 608</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Mail className="text-[#0284C7] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="font-medium text-[#0F172A]">E-Mail</p>
                  <ProtectedEmail />
                </div>
              </div>

              <div className="flex items-start gap-3">
                <FileText className="text-[#0284C7] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="font-medium text-[#0F172A]">Rechtliche Angaben</p>
                  <p>MwSt.-Nr./Partita IVA: IT 02706840218</p>
                  <p>Empfängercode (SDI): T04ZHR3</p>
                  <p>Eingetragen im Handelsregister Bozen</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Clock className="text-[#0284C7] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="font-medium text-[#0F172A]">Erreichbarkeit</p>
                  <p>Montag – Freitag: 7:00 – 18:00 Uhr</p>
                </div>
              </div>
            </div>
          </div>

          {/* Verantwortlich für den Inhalt */}
          <div className="bg-white rounded-xl p-8 border border-[#E2E8F0] mb-8">
            <h2 className="text-xl font-semibold text-[#0F172A] mb-4 font-[var(--font-heading)]">
              Verantwortlich für den Inhalt gemäß Art. 55 D.Lgs. 203/2021
            </h2>
            <p className="text-[#475569]">
              HAFNER EC GmbH<br />
              Sinich-Bach-Str. 60<br />
              I-39012 Meran (BZ)<br />
              Italien
            </p>
          </div>

          {/* EU-Streitschlichtung */}
          <div className="bg-white rounded-xl p-8 border border-[#E2E8F0] mb-8">
            <h2 className="text-xl font-semibold text-[#0F172A] mb-4 font-[var(--font-heading)]">
              EU-Streitschlichtung
            </h2>
            <p className="text-[#475569] mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            </p>
            <p>
              <a 
                href="https://ec.europa.eu/consumers/odr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#0284C7] hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="text-[#475569] mt-4 text-sm">
              Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder 
              verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

          {/* Haftungsausschluss */}
          <div className="bg-white rounded-xl p-8 border border-[#E2E8F0] mb-8">
            <h2 className="text-xl font-semibold text-[#0F172A] mb-4 font-[var(--font-heading)]">
              Haftungsausschluss (Disclaimer)
            </h2>
            
            <div className="space-y-6 text-[#475569] text-sm">
              <div>
                <h3 className="font-medium text-[#0F172A] mb-2">Haftung für Inhalte</h3>
                <p>
                  Als Diensteanbieter sind wir gemäß Art. 2 D.Lgs. 70/2003 für eigene Inhalte 
                  auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach Art. 14-16 
                  D.Lgs. 70/2003 sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte 
                  oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, 
                  die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
              </div>

              <div>
                <h3 className="font-medium text-[#0F172A] mb-2">Haftung für Links</h3>
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
                  keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
                  Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                  Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden 
                  zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige 
                  Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                </p>
              </div>

              <div>
                <h3 className="font-medium text-[#0F172A] mb-2">Urheberrecht</h3>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                  unterliegen dem italienischen und deutschen Urheberrecht. Die Vervielfältigung, 
                  Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des 
                  Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. 
                  Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht 
                  kommerziellen Gebrauch gestattet.
                </p>
              </div>
            </div>
          </div>

          {/* Hinweis zu interaktiven Inhalten */}
          <div className="bg-[#F8FAFC] rounded-xl p-8 border border-[#E2E8F0]">
            <h2 className="text-xl font-semibold text-[#0F172A] mb-4 font-[var(--font-heading)]">
              Hinweis zu den interaktiven Inhalten
            </h2>
            <p className="text-[#475569] text-sm">
              Die auf tippspiel.it angebotenen Quiz, Schätzspiele und Entscheidungshilfen 
              dienen ausschließlich der allgemeinen Information und Orientierung. Sie 
              ersetzen keine professionelle Beratung durch Immobilienmakler, Architekten, 
              Finanzberater, Rechtsanwälte oder andere Fachleute. Alle Angaben zu Preisen 
              und Kosten sind unverbindliche Richtwerte und können von den tatsächlichen 
              Marktbedingungen abweichen. Die Nutzung der interaktiven Elemente erfolgt 
              auf eigene Verantwortung.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
